/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import {
  type APIPermissions,
  ScenarioAPIPermissions,
  ToolAPIPermissions,
} from '@poweralpha/common';

export const hasFimoConfigAccessPermission = (
  permissions: Array<APIPermissions> | undefined,
): boolean =>
  Boolean(
    permissions?.includes(ToolAPIPermissions.READ_FIMO) ||
      permissions?.includes(ScenarioAPIPermissions.WRITE_APPROVAL_ENGINEERING),
  );

export const hasFimoDevFeePermission = (permissions: Array<APIPermissions> | undefined): boolean =>
  Boolean(permissions?.includes(ToolAPIPermissions.READ_FIMO));
